export const getParameterByName = (name, url) => {
    if (!url) url = window.location.href;
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[\]]/g, '\\$&');
    // eslint-disable-next-line no-useless-escape
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    // eslint-disable-next-line no-useless-escape
    const results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return '';

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};